import React from "react";
import {BaseRendererProps} from "../BaseRendererProps";
import BaseCreatedDateRenderer from "./BaseCreatedDateRenderer";
import {GridRendererProps} from "../GridRendererProps";

export default React.memo(function GridCreatedDateRenderer(props: GridRendererProps) {
  // @ts-ignore
  const p: BaseRendererProps<any> = {
    ...props.column.params,
    value: props.row['createdOn'],
  }

  return (
    // @ts-ignore
    <BaseCreatedDateRenderer {...p}/>
  )
})